import {H1} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import React from "react"
import styled from "styled-components"

const DepartmentHeader = () => {
  const theme = useTheme()
  return (
    <Container>
      <H1 color={theme.colors.greys.white}>Computing & Gaming</H1>
    </Container>
  )
}

export default DepartmentHeader

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  background: linear-gradient(0.25turn, #1e2aba, #30bae3);

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    height: 120px;
  `}
`
